import React, { useCallback } from "react"
import Slider from "react-slick"
import estates from "../../assets/json/estates/estates.json"
import { COUNTRY_LIST } from "../../assets/country/country"
import starIcon from "../../assets/images/icons/star-2-48.png"
import Empty from "../../assets/images/empty.svg"

const SliderEstate = ({ pageContext: { translate } }) => {
  let settings = {
    slidesToShow: 4,
    arrows: true,
    doys: false,
    infinite: false,
    speed: 500,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1270,
        settings: {
          slidesToShow: 4,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 1140,
        settings: {
          slidesToShow: 3,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          initialSlide: 0,
        },
      },
    ],
  }

  const openEstate = useCallback(slug => {
    window.open(
      `${process.env.GATSBY_SITE_URL}/estate/${slug}/green-coffee`,
      "_blank"
    )
  }, [])

  return (
    <>
      {
        <div className="slider-roster">
          <div className="content">
            <div className="pb-5">
              <h2>{translate.t?.source_coffee}</h2>
            </div>
            <Slider {...settings}>
              {Array.isArray(estates) &&
                estates.map(item => (
                  <div
                    className="SipiBanner border br-4 cursor-pointer"
                    onClick={() => openEstate(item.slug)}
                  >
                    <img
                      className={`img-fluid cmp-img ${
                        item.company_image_url ? "" : "p-5 bg-eb"
                      }`}
                      src={item.company_image_url || Empty}
                      alt={item.company_name}
                    />
                    <div className="d-flex justify-content-between px-3">
                      <div className="pt-4">
                        <p className="text-medium bold">{item.name}</p>
                        {
                         item.rating > 0 &&     
                         <p className="heading-h12 text-medium bold pt-2 d-flex">
                         <img
                           height={14}
                           src={starIcon}
                           alt="rating"
                           className="pr-1"
                         />
                         {item.rating.toFixed(2)}
                        </p>
                        } 
                      </div>
                      <div className="pt-4">
                        <img
                          src={item?.company_image_url}
                          alt={item?.company_name}
                          height={24}
                          width={24}
                          className="img-fluid"
                        />
                      </div>
                    </div>

                    <div className="row mx-0 px-2 mx-1">
                      <div className="col-4 px-1 my-2">
                        <p className="heading-h12 text-medium my-1">Origin</p>
                        <p className="heading-h12 text-medium bold my-1">
                          {
                            COUNTRY_LIST.find(c => c.isoCode === item?.country)
                              ?.name
                          }{" "}
                        </p>
                      </div>
                      <div className="col-4 px-1 my-2">
                        <p className="heading-h12 text-medium my-1">Region</p>
                        <p className="heading-h12 text-medium bold my-1">
                          {item.region}
                        </p>
                      </div>
                      <div className="col-4 px-1 my-2">
                        <p className="heading-h12 text-medium  my-1">
                          Altitude
                        </p>
                        <p className="heading-h12 text-medium bold my-1">
                        {item?.min_altitude && item?.max_altitude ? 
                          `${item.min_altitude} - ${item.max_altitude} m` : 
                         "N/A"}
                        </p>
                      </div>
                      <div className="col px-1 my-2">
                        <p className="heading-h12 text-medium my-1">Varietal</p>
                        <p className="heading-h12 text-medium my-1">
                          {item.varieties?.length >0 ? item.varieties.slice(0,5).map(variety =>(<span className="pill mb-1"> {variety.name}</span>)) : "NA"}
                        </p>
                      </div>
                    </div>

                    <div className="px-3 pb-3">
                      <hr />
                      <p className="heading-h12 text-medium my-1">Top plots</p>
                      <p className="heading-h12 text-medium my-1 ">
                        {item.lots?.length >0 ? item.lots.slice(0, 3).map(lot => (<span  className="pill-lots">{lot.name}</span>)) : <span>NA</span>}
                      </p>
                    </div>
                  </div>
                ))}
            </Slider>
          </div>
        </div>
      }
    </>
  )
}

export default SliderEstate
